export const FilterConstant = {
    agents_applied_filter: 'agents_applied_filter',
    search_agents_applied_filter:'search_agents_applied_filter',
    non_agents_applied_filter:'non_agents_applied_filter',
    agents_applied_filter_view: 'agents_applied_filter_view',
    counsellor_applied_filter: 'counsellor_applied_filter',
    application_master_applied_filter: 'application_master_applied_filter',
    application_master_applied_view_filter: 'application_master_applied_view_filter',
    university_applied_filter: 'university_applied_filter',
    university_requirement_applied_filter: 'university_requirement_applied_filter',
    university_entry_applied_filter: 'university_entry_applied_filter',
    university_affiliate_applied_filter: 'university_affiliate_applied_filter',
    university_process_applied_filter: 'university_process_applied_filter',
    university_filter_filters_applied_filter:
        'university_filter_filters_applied_filter',
    university_ug_applied_filter: 'university_ug_applied_filter',
    university_pg_applied_filter: 'university_pg_applied_filter',
    university_email_applied_filter: 'university_email_applied_filter',
    course_applied_filter: 'course_applied_filter',
    tenant_applied_filter: 'tenant_applied_filter',
    sub_tenant_filter: 'sub_tenant_filter',
    user_applied_filter: 'user_applied_filter',
    user_group_filter: 'user_group_filter',
    board_applied_filter: 'board_applied_filter',
    marksheet_applied_filter: 'marksheet_applied_filter',
    qualification_applied_filter: 'qualification_applied_filter',
    university_contract_applied_filter: 'qualification_applied_filter',
    agent_commission_applied_filter: 'agent_commission_applied_filter',
    art_filter: 'art_filter',
    cat_filter: 'cat_filter',
    cat_all_filter: 'cat_all_filter',
    cat_own_filter: 'cat_my_filter',
    cpt_filter: 'cpt_filter',
    cabin_filter: 'cabin_filter',
    company_filter: 'company_filter',
    employee_filter: 'employee_filter',
    job_role_filter: 'job_role_filter',
    country_filter: 'country_filter',
    state_filter: 'state_filter',
    regions_filter: 'regions_filter',
    continent_filter: 'continent_filter',
    docRestriction_filter: 'docRestriction_filter',
    smtp_filter: 'smtp_filter',
    email_template_filter: 'email_template_filter',
    interview_master_filter: 'interview_master_filter',
    interview_assign_filter: 'interview_assign_filter',
    interview_request_filter: 'interview_request_filter',
    interview_view_filter: 'interview_view_filter',
    interview_quality_filter: 'interview_quality_filter',
    cas_master_applied_filter: 'cas_master_applied_filter',
    confirmation_awaited_applied_filter: 'confirmation_awaited_applied_filter',
    ready_to_claim_filter: 'ready_to_claim_filter',
    notification_filter: 'notification_filter',
    chat_filter: 'chat_filter',
    automation_log: 'automation_log',
    ip_address: 'ip_address',
    secondary_status_filter: 'secondary_status_filter',
    primary_status_filter: 'primary_status_filter',
    reports_applied_filter: 'reports_applied_filter',
    qc_reports_applied_filter: 'qc_reports_applied_filter',
    quality_check_filter:'quality_check_filter',
    voucher_filter:'voucher_filter',
    call_logs_filter: 'call_logs_applied_filter',
    payment_filter: 'payment_filter',
    aiInterview_filter: 'aiInterview_filter',
    partner_applied_filter: 'partner_applied_filter',
    ambar_applied_filter: 'ambar_applied_filter',
    deadline_filter: 'deadline_filter',
    enquiry_filter: 'enquiry_filter',
};
export const defaultOptionUK = {
    "_id": "65d8296027f2c83f8f9e64d6",
    "id": "222",
    "name": "United Kingdom",
    "status": "true",
    "createdAt": "2024-02-23T05:13:04.385+0000",
    "updatedAt": "2024-02-23T05:13:04.386+0000",
    "countryList": {
        "flag": "/catalog/icon/united_kingdom_flag.png"
    }
}
